import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql, withApollo } from '@apollo/react-hoc';
import get from 'lodash/get';
import React from 'react';
import throttle from 'lodash/throttle';
import { withRouter, routerShape } from 'react-router';
import Message from '../../components/Message';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import viewedMutation from './viewedmutation';
import './styles.css';

export const publishedAnnouncementQuery = gql`
  query inProdNotifications {
    viewer {
      id
      publishedAnnouncement{
        id
        title
        content
        status
        audience
        createdDate
      }
    }
  }
`;

export class InProdNotificationComponent extends React.Component {
  static propTypes = {
    client: PropTypes.shape({
      query: PropTypes.func.isRequired,
    }).isRequired,
    router: routerShape,
    onReadMoreClick: PropTypes.func,
    onContentClick: PropTypes.func,
    markAnnouncementViewed: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this._fetchAnnouncement = throttle(async () => {
      const response = await this.props.client.query({
        fetchPolicy: 'no-cache',
        query: publishedAnnouncementQuery,
      });
      this.setState({ publishedAnnouncement: get(response, 'data.viewer.publishedAnnouncement') });
    }, 30 * 1000, { leading: true, trailing: false });
  }

  state = {
    publishedAnnouncement: null,
    isButtonActive: false,
  };

  componentDidMount() {
    this._fetchAnnouncement();
    this.routerListener = this.props.router.listen(() => this._fetchAnnouncement());
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    this.routerListener();
    window.removeEventListener('resize', this.resizeWindow);
  }

  onReadMoreClick = () => {
    this.props.onReadMoreClick(this.state.publishedAnnouncement);
  };

  onContentDataClick = (publishedAnnouncement) => {
    /* istanbul ignore if */
    if (this.refContent.offsetWidth < this.refContent.scrollWidth) {
      this.props.onContentClick(publishedAnnouncement);
    }
  }

  resizeWindow = () => {
    if (this.refReadMoreDiv) {
      if (!this.state.isButtonActive && this.refReadMoreDiv.offsetWidth < this.refReadMoreDiv.scrollWidth) {
        this.setState({ isButtonActive: true });
      } else if (this.state.isButtonActive && this.refReadMoreDiv.offsetWidth >= this.refReadMoreDiv.scrollWidth) {
        this.setState({ isButtonActive: false });
      }
    }
  }

  updateViewedMutation = (viewedNotification) => {
    // todo: what do we do if there's an error clearing the notification?
    this.props.markAnnouncementViewed({
      variables: {
        input: {
          announcementId: this.state.publishedAnnouncement.id,
        },
      },
    }).then(() => this.setState({ publishedAnnouncement: null }));
  };

  refReadMore =(element) => {
    this.refReadMoreDiv = element;
    if (this.refReadMoreDiv && this.refReadMoreDiv.offsetWidth < this.refReadMoreDiv.scrollWidth) {
      this.setState({ isButtonActive: true });
    }
  }

  render() {
    const { isButtonActive, publishedAnnouncement } = this.state;
    return publishedAnnouncement && (
      <Message info size="small" icon className="toast persistent" styleName="Nav-banner">
        <Icon name="announcement" styleName="Nav-banner-icon" />
        <Message.Content styleName="content-header">
          <div styleName="content" className="hidden-mobile hidden-tablet" ref={this.refReadMore}>
            <b>{publishedAnnouncement.title}</b>
            <span styleName="alignNavText">{publishedAnnouncement.content}</span>
          </div>
          <div className="hidden-computer" id="content-more" styleName="contentMore" ref={(e) => { this.refContent = e; }}>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <a
              styleName="contentHeader"
              id="content-header"
              tabIndex="0"
              onClick={() => this.onContentDataClick(publishedAnnouncement)}
            >
              <b>{publishedAnnouncement.title}</b>
              <span styleName="alignNavText">{publishedAnnouncement.content}</span>
            </a>
          </div>
          <Button
            icon
            id="close-announcement-details"
            aria-label="Close Announcement"
            styleName="close"
            onClick={this.updateViewedMutation}
          >
            <Icon
              name="close"
              styleName="Nav-banner-icon-close"
            />
          </Button>
          {isButtonActive && (
          <Button
            id="read-more-announcement-button"
            onClick={this.onReadMoreClick}
            styleName="readmore"
            className="hidden-mobile hidden-tablet"
          >Read More
          </Button>
          )}
        </Message.Content>
      </Message>
    );
  }
}
const announcementViewed = graphql(viewedMutation, {
  name: 'markAnnouncementViewed',
});

export default withRouter(withApollo(announcementViewed(InProdNotificationComponent)));
